import React, { useEffect, useState } from 'react';
import { researchosService } from '../../services/researchosService';
import RedditSourcesPanel from './RedditSourcesPanel';
import TranscriptBrowser from './TranscriptBrowser';
import ExtractionStudio from './ExtractionStudio';

const GOLD = 'rgb(var(--brand-gold-rgb))';

// Chatter → Reddit (wish #13, 2026-10-13). The platform never fetches Reddit: the owner's Mac mini runs the
// collector on a cron through its logged-in Chrome and pushes through the Courier connector. This page is the
// Reddit PLUMBING only — the analysis of Reddit documents flows through the same extraction → graph → rails as
// transcripts and X posts:
//   • Sources — the platform-owned worklist: add a subreddit or search (it backfills itself on the next nightly
//     run), pause / resume, edit limits and flags, ask for a fresh backfill
//   • Documents — the stored source-day documents (same browser as transcripts, scoped to Reddit)
//   • Extraction — preview / commit / bulk-run DeepSeek on Reddit documents (same studio, scoped to Reddit)
const TABS = [
  { id: 'sources', label: 'Sources' },
  { id: 'documents', label: 'Documents' },
  { id: 'extract', label: 'Extraction (DeepSeek)' },
];

function TabBtn({ on, children, onClick }) {
  return (
    <button onClick={onClick} className="rounded px-3 py-1.5 text-sm transition-colors"
      style={on ? { color: GOLD, border: `1px solid ${GOLD}`, fontWeight: 500 } : { border: '1px solid transparent', color: '#6b7280' }}>
      {children}
    </button>
  );
}

export default function RedditPipelinePage() {
  const [scope, setScope] = useState(null);
  const [loading, setLoading] = useState(true);
  const [tab, setTab] = useState('sources');

  useEffect(() => {
    let alive = true;
    researchosService.getScope()
      .then((r) => { if (alive) setScope(r.data); })
      .catch(() => { if (alive) setScope({ is_admin: false }); })
      .finally(() => { if (alive) setLoading(false); });
    return () => { alive = false; };
  }, []);

  if (loading) return <div className="text-gray-500 dark:text-gray-400">Loading…</div>;
  if (!scope?.is_admin) {
    return (
      <p className="text-sm text-gray-500 dark:text-gray-400">
        Reddit ingest is administered by the platform owner. Its posts feed the shared Signal, Narrative and Relationships views under YouTube.
      </p>
    );
  }

  return (
    <div>
      <div className="mb-4 flex flex-wrap items-end justify-between gap-2">
        <div>
          <h2 className="font-serif text-xl text-gray-900 dark:text-gray-100">Reddit Chatter</h2>
          <p className="mt-0.5 text-sm text-gray-500 dark:text-gray-400">
            Tracked subreddits and searches — read nightly by the collector on the Mac mini, one document per source per posting day, extracted by the daily chain like a transcript.
          </p>
        </div>
        <span className="font-mono text-[9px] uppercase tracking-[0.15em] text-green-500">● Live</span>
      </div>
      <nav className="mb-5 flex flex-wrap items-center gap-1">
        {TABS.map((t) => <TabBtn key={t.id} on={tab === t.id} onClick={() => setTab(t.id)}>{t.label}</TabBtn>)}
      </nav>
      {tab === 'sources' && <RedditSourcesPanel />}
      {tab === 'documents' && <TranscriptBrowser sourceType="reddit" />}
      {tab === 'extract' && <ExtractionStudio sourceType="reddit" />}
    </div>
  );
}
